"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSetting = exports.fetchSettings = void 0;

var _memoize = _interopRequireDefault(require("../utilities/memoize"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var portalId = _PortalIdParser.default.get();

var url = "hubs/v1/hubs/" + portalId + "/settings";
var fetchSettings = (0, _memoize.default)(function () {
  return _apiClient.default.get(url);
});
exports.fetchSettings = fetchSettings;

var setSetting = function setSetting(key, value) {
  return _apiClient.default.post(url, {
    data: {
      hubId: portalId,
      internal: false,
      key: key,
      value: value
    }
  });
};

exports.setSetting = setSetting;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/api/settingsApi.js
// module id = 498
// module chunks = 5 6